import _ from 'lodash';
import airportPorts from '../../airports-parsed.json';

function productToMonada(p) {
    if (p === 'FL20') return '20\' Flat';
    if (p === 'FL40') return '40\' Flat';
    if (p === 'OT20') return '20\' Open Top';
    if (p === 'OT40') return '40\' Open Top';
    if (p === 'DV20') return '20\' Dry';
    if (p === 'DV40') return '40\' Dry';
    if (p === 'HC40') return '40\' HC Dry';

    if (p === '20FL') return '20\' Flat';
    if (p === '40FL') return '40\' Flat';
    if (p === '20OT') return '20\' Open Top';
    if (p === '40OT') return '40\' Open Top';
    if (p === '20DV') return '20\' Dry';
    if (p === '40DV') return '40\' Dry';
    if (p === '40HC') return '40\' HC Dry';
    if (p === '20\' RG') return '20\' Dry';
    if (p === '40\' RG') return '40\' Dry';
    if (p === '40\' HC') return '40\' HC Dry';

    if (p === '20\'DV') return '20\' Dry';
    if (p === '40\'DV') return '40\' Dry';
    if (p === '40\'HQ') return '40\' HC Dry';

    if (p === '20GP') return '20\' Dry';
    if (p === '40GP') return '40\' Dry';

    if (p === 'FIX per b/l') return 'route';
    if (p === 'FIX PER B/L') return 'route';
    if (p === '(PER B/L)') return 'route';
    if (p === '(per B/L)') return 'route';
    if (p === 'LCL') return 'LCL';
    if (p === '20RF') return '20\' Reefer';
    if (p === '40RF') return '40\' Reefer';
    if (p === '45RF') return '45\' Reefer';
    if (p === '40HCRF') return '40\' HC Reefer';
    if (p === '40HR') return '40\' HC Reefer';
    if (p === '45HCRF') return '45\' HC Reefer';
    return '';
}

function datePartsToString(date) {
    let year = parseInt(date[2]);
    if (year < 100) year += 2000;

    return `${year}-${date[1]}-${date[0]}`;
}

function matchPort({ name, seaPorts }) {
    const n = _.trim(name);

    const perfectCode = seaPorts.find(p => p.code === n);
    if (perfectCode) return perfectCode;

    const perfectName = seaPorts.find(p => n.toUpperCase() === p.portname.toUpperCase());
    if (perfectName) return perfectName;


    const inAKA = seaPorts.find(p => ((p.aka || []).includes(n.toUpperCase())));
    if (inAKA) return inAKA;

    const subName = seaPorts.find(p => n.toUpperCase().indexOf(p.portname.toUpperCase()) > -1);
    if (subName) return subName;
    
    const airport = airportPorts.find(p => ('' + p.ident).toUpperCase() === n.toUpperCase());
    if (airport) return airport;

    return null;
}


export { productToMonada, datePartsToString, matchPort };
